import { render, staticRenderFns } from "./SharedTipsManager.vue?vue&type=template&id=71ec3fc6&scoped=true&"
import script from "./SharedTipsManager.vue?vue&type=script&lang=js&"
export * from "./SharedTipsManager.vue?vue&type=script&lang=js&"
import style0 from "./SharedTipsManager.vue?vue&type=style&index=0&id=71ec3fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec3fc6",
  null
  
)

export default component.exports